

function TopHeading({heading}) {
  return (
    <h1 className="heading">{heading}</h1>
  )
}

export default TopHeading